<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="toEdit(scope.row)">
          <span class="el-icon-edit"></span>编辑
        </el-button>
        <el-button type="text" size="small" @click="toDelete(scope.row)">
          <span class="el-icon-delete"></span>删除
        </el-button>
      </template>
    </avue-crud>
    <div v-show="showParkForm">
      <avue-form
        ref="parRegionForm"
        v-model="form"
        :rules="rules"
        :option="option"
        @submit="submit"
      >
        <!-- <template slot-scope="scope" slot="menuForm">
                <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
              </template> -->
      </avue-form>
    </div>
  </basic-container>
</template>

<script>
import {
  getParkParent,
  getRegionList,
  numberCheck,
  stringCheck,
  getChildrenDeptByDeptId,
  removeRegion,
} from '@/views/v4ward/carv2/merge/api/park-merge';
import { update, addParkSpaceNode } from '@/api/v4ward/carv2/carpark';
import { syncData } from '@/api/v4ward/carv2/carparkspace';
export default {
  props: {
    parkSpace: {},
    showBaseForm: false,
    saveBtnShow: false,
  },
  data() {
    var checkRegion = (rule, value, callback) => {
      if (value === this.form.id) {
        callback(new Error('父级节点不能选自己！'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showParkForm: false,
      operateType: '',
      form: {},
      syncButtonLoading: false,
      next: false,
      spaceId: '',
      option: {
        labelWidth: 110,
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        align: 'center',
        menuWidth: 150,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '区域名称',
            prop: 'spaceName',
            rules: [
              {
                required: true,
                trigger: 'blur',
                message: '请输入区域名称',
              },
              {
                validator: stringCheck,
                min: 2,
                max: 10,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上级节点',
            prop: 'parentId',
            type: 'tree',
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择上级节点',
                trigger: 'blur',
              },
              {
                validator: checkRegion,
                message: '请选择上级节点',
                trigger: 'change',
              },
            ],
            //dicUrl: '/api/v4ward/carv2/ParkSpace/merge/regionParentNodes?id=' + this.parkSpace.id,
            dicData: [],
          },
          {
            label: '车位数',
            prop: 'parkLotNumber',
            type: 'number',
            rules: [
              {
                required: true,
                message: '请输入车位数',
                trigger: 'blur',
              },
              {
                validator: numberCheck,
                min: 10,
                max: 10000,
                trigger: 'blur',
              },
            ],
          },
          // {
          //   label: '临停车位',
          //   prop: 'tempParkFlag',
          //   type: 'select',
          //   dicData: [
          //     { label: '是', value: '1' },
          //     { label: '否', value: '0' },
          //   ]
          // },
          // {
          //   label: '状态',
          //   prop: 'carParkStatus',
          //   type: 'select',
          //   dataType: 'number',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=car_park_status',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   }
          // },

          {
            label: '单独计费',
            prop: 'regionFeeType',
            display: false,
          },
          {
            showColumn: false,
            label: '单独计费',
            prop: 'carParkAreaType',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_fee_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择是否单独计费',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '区域收费部门',
            prop: 'regionDeptId',
            type: 'tree',
            hide: true,
            display: false,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择区域收费部门',
                trigger: 'blur',
              },
            ],
            //dicUrl: '/api/v4ward/carv2/ParkSpace/merge/regionParentNodes?id=' + this.parkSpace.id,
            dicData: [],
          },
          {
            label: '区域收费部门',
            prop: 'regionDeptName',
            type: 'tree',
            display: false,
            search: false,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '本地编号',
            prop: 'blockLocalNo',
            span: 24,
            hide: true,
            display: false,
          },
        ],
      },
    };
  },
  watch: {
    'form.carParkAreaType'() {
      if (this.form.carParkAreaType == 3) {
        this.initRegionDept();
        // this.option.column[6].display = true;
      } else {
        this.option.column[6].display = false;
        this.form.regionDeptId = '';
      }
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      document.querySelector('#pane-parkRegion > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-parkRegion > div > div > div > div.avue-crud > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
    });
  },
  methods: {
    formSubmit(next) {
      if (next) {
        this.next = next;
        if (this.data.length) {
          this.$emit('getQuestionResult', this.next);
        } else {
          this.$message({
            message: '请至少添加一条数据，再执行该操作。',
            type: 'warning',
          });
        }
      } else {
        this.next = false;
        this.$refs.parRegionForm.submit();
      }
    },
    openAddForm() {
      this.operateType = 'add';
      console.log('row>>>>>>>', this.parkSpace);
      this.cleanForm();
      this.showParkForm = !this.showParkForm;
      this.saveBtnShow = this.showParkForm;
      this.$emit('update:saveBtnShow', this.showParkForm);
    },
    toEdit(row) {
      this.operateType = 'edit';
      this.form = Object.assign({}, row);
      this.showParkForm = !this.showParkForm;
      this.saveBtnShow = this.showParkForm;
      this.$emit('update:saveBtnShow', this.showParkForm);
    },
    toDelete(row) {
      this.$confirm('确定删除该区域?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeRegion({ id: row.id, parkId: this.parkSpace.id })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.onLoad();
          })
          .catch(() => {
            this.onLoad();
          });
      });
    },
    onLoad() {
      this.loading = true;
      getRegionList({ parkId: this.parkSpace.id, spaceName: this.spaceName, type: 3 }).then(
        (data) => {
          this.data = data.data;
          this.loading = false;
          this.initParkParentList();
        }
      );
    },
    initRegionDept() {
      console.log('初始化区域部门数据');
      getChildrenDeptByDeptId({
        tenantId: this.parkSpace.tenantId,
        deptId: this.parkSpace.deptId,
      }).then((data) => {
        let regionDeptIdColumn = this.findObject(this.option.column, 'regionDeptId');
        regionDeptIdColumn.dicData = data.data;
        this.option.column[6].display = true;
        // this.$refs.crud.dicInit()
        // this.regionDeptId = data.data;
      });
    },
    initParkParentList(force) {
      if (this.spaceId === '' || this.spaceId !== this.parkSpace.id || force) {
        getParkParent({ id: this.parkSpace.id }).then(({ data }) => {
          const col = this.findObject(this.option.column, 'parentId');
          if (this.vdui.isNotEmpty(data)) {
            col.dicData = data;
          } else {
            col.dicData = [{}];
          }
        });
      }
      this.spaceId = this.parkSpace.id;
      if (this.parkSpace.equType === 3) {
        const blockLocalNo = this.findObject(this.option.column, 'blockLocalNo');
        blockLocalNo.display = true;
      } else {
        const blockLocalNo = this.findObject(this.option.column, 'blockLocalNo');
        blockLocalNo.display = false;
      }
    },

    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    submit(form, done) {
      this.form.type = 3;
      if (this.vdui.isEmpty(this.form.tempParkFlag)) {
        this.form.tempParkFlag = 0;
      }
      if (this.vdui.isEmpty(this.form.carParkStatus)) {
        this.form.carParkStatus = 0;
      }
      if (this.vdui.isEmpty(form.id)) {
        addParkSpaceNode(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.initParkParentList(true);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else {
        update(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.initParkParentList(true);
            this.showParkForm = false;
            this.saveBtnShow = this.showParkForm;
            this.$emit('update:saveBtnShow', this.showParkForm);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    syncParkInfo(type) {
      this.syncButtonLoading = true;
      const syncParam = {
        dataRange: 2,
        dataType: type,
        parkId: this.parkSpace.id,
      };
      syncData(syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.syncButtonLoading = false;
        },
        (error) => {
          window.console.log(error);
          this.syncButtonLoading = false;
        }
      );
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
    },
  },
};
</script>
<style scoped></style>
